import { cn } from "@/lib/utils";

interface SectionDividerProps {
  className?: string;
  variant?: "accent" | "subtle";
}

export function SectionDivider({ className, variant = "accent" }: SectionDividerProps) {
  return (
    <div role="separator" aria-orientation="horizontal" className={cn("w-full flex justify-center py-2", className)}>
      <div
        className={cn(
          "h-px w-full max-w-2xl",
          variant === "accent"
            ? "bg-gradient-to-r from-transparent via-accent/30 to-transparent"
            : "bg-gradient-to-r from-transparent via-secondary/20 to-transparent"
        )}
      />
    </div>
  );
}